module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19BwK6s/tc-custom/9781426890963.jpg?1705019890927",
      "alt": "This image is the cover for the book Like Clockwork"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Like Clockwork\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Victoria's work with automatons has gained her renown and changed the face of London. But her concern that the clockworks are taking too many jobs away from humans, creating social unrest, is ignored. Given the ugly mood of the underclass, she fears more outbreaks of violence similar to the murder spree of the notorious Southwark Slasher."), _c('br'), _c('br'), _vm._v("Dash, unemployed thanks to the clockworks, has pledged fealty to The Brotherhood, a group determined to bring about the downfall of the automatons by any means necessary. His plan to kidnap Victoria goes awry when the unorthodox scientist pledges her assistance to their cause."), _c('br'), _c('br'), _vm._v("Despite their opposite social classes, a bond grows between them, and Victoria begins to feel emotions she never expected for the passionate Dash. But when the Slasher strikes close to home, Dash and Victoria realize that the boundaries of polite society are far from the only threat to their happiness..."), _c('br'), _c('br'), _vm._v("31,000 words")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bonnie Dee\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Carina Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0